/* CHAO enquiry-only campaign isolation, 19 October 2026.
 * Standard Google commands relay only consented claimed acceptance.
 * Existing legacy click/call/ecommerce producers remain the owners.
 */
/* CHAO production consent reader candidate. HOLD: runtime QA required.
 * Reads effective Shopify purpose permissions; never records visitor choices.
 * No cookies, browser storage, customer data, network calls or measurement.
 */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (root && root.document) api.install(root);
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  var HOST = 'chaocatering.com.au';
  var KEY = '__chaoConsentV1';

  function eligibility(state) {
    return {
      analytics: !!state && state.ready === true && state.analytics === true,
      ads: !!state && state.ready === true && state.marketing === true && state.saleOfData === true
    };
  }

  function install(win) {
    if (!win.location || win.location.hostname !== HOST) return null;
    if (win[KEY]) return win[KEY];
    var doc = win.document;
    var loaded = false;
    var loading = false;
    var subscribers = [];
    var previous = null;
    var instantClickBound = false;

    function unknown() {
      return { version: 1, ready: false, analytics: null, marketing: null, saleOfData: null };
    }
    function readEffective() {
      var privacy;
      try { privacy = win.Shopify && win.Shopify.customerPrivacy; } catch (_) { return unknown(); }
      if (!loaded || !privacy) return unknown();
      function read(name) {
        try {
          if (typeof privacy[name] !== 'function') return null;
          var value = privacy[name].call(privacy);
          return typeof value === 'boolean' ? value : null;
        } catch (_) { return null; }
      }
      return {
        version: 1, ready: true,
        analytics: read('analyticsProcessingAllowed'),
        marketing: read('marketingAllowed'),
        saleOfData: read('saleOfDataAllowed')
      };
    }
    function getEligibility() { return eligibility(readEffective()); }
    function queueState() {
      try {
        if (typeof win.dataLayer === 'undefined') win.dataLayer = [];
        if (!win.dataLayer || typeof win.dataLayer.push !== 'function') return false;
        // This event is only a wake-up. GTM rereads the API through readEffective.
        win.dataLayer.push({ event: 'chao_consent_state' });
        return true;
      } catch (_) { return false; }
    }
    function same(a, b) {
      return a && b && a.ready === b.ready && a.analytics === b.analytics &&
        a.marketing === b.marketing && a.saleOfData === b.saleOfData;
    }
    function notify() {
      var current = readEffective();
      var changed = !same(previous, current);
      var prior = previous;
      previous = current;
      if (changed) {
        // Subscribers may invalidate existing pending purpose eligibility. A grant
        // does not authorize replay; this module emits no measurement events.
        subscribers.slice().forEach(function (listener) {
          try { listener(current, prior); } catch (_) { /* One observer cannot stop consent updates. */ }
        });
      }
      queueState();
      return current;
    }
    function bindNavigation() {
      try {
        if (!instantClickBound && win.InstantClick && typeof win.InstantClick.on === 'function') {
          win.InstantClick.on('change', refresh);
          instantClickBound = true;
        }
      } catch (_) { /* Other navigation events still refresh consent. */ }
    }
    function refresh() {
      bindNavigation();
      if (loaded) return notify();
      var shopify;
      try { shopify = win.Shopify; } catch (_) { return unknown(); }
      if (loading || !shopify || typeof shopify.loadFeatures !== 'function') return unknown();
      loading = true;
      try {
        shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
          loading = false;
          if (!error) loaded = true;
          notify();
        });
      } catch (_) {
        loading = false;
        notify();
      }
      return readEffective();
    }
    function subscribe(listener) {
      if (typeof listener !== 'function') return function () {};
      subscribers.push(listener);
      return function () { subscribers = subscribers.filter(function (fn) { return fn !== listener; }); };
    }

    var controller = {
      version: 1,
      readEffective: readEffective,
      getEligibility: getEligibility,
      queueState: queueState,
      refresh: refresh,
      subscribe: subscribe
    };
    win[KEY] = controller;
    doc.addEventListener('DOMContentLoaded', refresh);
    doc.addEventListener('visitorConsentCollected', refresh);
    doc.addEventListener('shopify:section:load', refresh);
    win.addEventListener('load', refresh);
    win.addEventListener('pageshow', refresh);
    refresh();
    return controller;
  }
  return { install: install, eligibility: eligibility };
});

;
/* CHAO campaign-context derivative; unpublished local validation required.
 * Native action-fragment nonce candidate. HOLD until actual Shopify round-trip,
 * rejection, CAPTCHA, delivery and mobile tests pass. No direct measurement sends.
 * A client submission ID correlates native success; it is not a Shopify receipt.
 */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (root && root.document) api.install(root);
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';

  var FALLBACK_URL = typeof URL === 'function' ? URL : null;
  var INSTALLED = '__chaoTrackingBridgeV4';
  var PENDING_KEY = 'chao.enquiry.pending.v4';
  var RECEIPTS_KEY = 'chao.enquiry.consumed.v4';
  var WRAPPER = '.form-quote-container';
  var ACCEPTANCE_SELECTOR = WRAPPER + ' [data-chao-native-success="true"]';
  var ERROR_SELECTOR = WRAPPER + ' [data-chao-native-error="true"]';
  var RETURN_FIELD = 'return_to';
  var NONCE_PREFIX = 'contact_form_';
  var ORIGINAL_ACTION = 'data-chao-original-native-action';
  var OWNED_ATTRIBUTE = 'data-chao-nonce-field';
  var CLAIM_DB = 'chao.enquiry.claims.v4';
  var CLAIM_STORE = 'claims';
  var PRIVACY_BLOCK = '__chao_privacy_block';
  var ATTEMPT_TTL = 30 * 60 * 1000;
  var CLAIM_TIMEOUT = 3000;
  var EPOCH_KEYS = { analytics: 'chao.privacy.analyticsEpoch.v1', ads: 'chao.privacy.adsEpoch.v1' };
  var ID_FIELD = 'contact[chao_tracking_submission_id]';
  var ROUTE_FIELD = 'contact[chao_tracking_form_route]';
  var CAMPAIGN_KEY = 'chao.enquiry.campaign.v1';
  var CAMPAIGN_ATTRIBUTE = 'data-chao-campaign-field';
  var CAMPAIGN_FIELDS = { analytics: ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'], ads: ['gclid', 'gbraid', 'wbraid'] };
  var CAMPAIGN_TTL = 30 * 60 * 1000;
  var UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  var own = function (object, key) { return Object.prototype.hasOwnProperty.call(object, key); };

  function routeForPath(path) {
    path = path.replace(/\/$/, '');
    if (path === '/pages/quote') return 'quote';
    if (path === '/pages/contact-us') return 'contact';
    return null;
  }

  function classifyLink(href, base, nativeURL) {
    var url;
    try { url = new (nativeURL || FALLBACK_URL)(href, base); } catch (_) { return null; }
    if (url.protocol === 'tel:') return 'click_to_call';
    if (url.protocol === 'mailto:') return 'click_to_email';
    if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
    var host = url.hostname.toLowerCase();
    if (host === 'maps.apple.com' || host === 'maps.app.goo.gl') return 'map_click';
    if (host === 'goo.gl' && /^\/maps(?:\/|$)/.test(url.pathname)) return 'map_click';
    if (/^(?:www\.)?google\.[a-z]{2,3}(?:\.[a-z]{2})?$/.test(host) && /^\/maps(?:\/|$)/.test(url.pathname)) return 'map_click';
    if (/^maps\.google\.[a-z]{2,3}(?:\.[a-z]{2})?$/.test(host)) return 'map_click';
    return null;
  }

  function install(win) {
    if (!win.location || win.location.hostname !== 'chaocatering.com.au') return null;
    if (win[INSTALLED]) return win[INSTALLED];
    // Retained legacy schema tags overwrite the global URL constructor.
    // The head bootstrap captures the native constructor before those tags run.
    var URL = typeof win.__chaoEnquiryURLConstructorV1 === 'function' ?
      win.__chaoEnquiryURLConstructorV1 : FALLBACK_URL;
    var doc = win.document;
    var instantClickBound = false;
    var subscribedConsent = null;
    var privacyCleanupFailed = false;
    var fullDenialCleaned = false;
    var claimsInFlight = {};
    var activeClaims = [];
    var lastKnownPermission = { analytics: null, ads: null };
    var campaignFailed = false;
    var nextCampaignNavigation = null;
    var campaignVisit = newCampaignVisit(initialCampaignNavigation());

    function readEpochs() {
      // Two local privacy-invalidation controls only: no customer/lead IDs,
      // no permission grants and never included in analytics/network payloads.
      try {
        var store = win.localStorage;
        if (!store) return null;
        var result = {};
        ['analytics', 'ads'].forEach(function (purpose) {
          var value = store.getItem(EPOCH_KEYS[purpose]);
          if (value === null) result[purpose] = 'none';
          else if (value.indexOf('r1:') === 0 && UUID.test(value.slice(3))) result[purpose] = value;
          else throw new Error('Invalid privacy generation');
        });
        return result;
      } catch (_) { return null; }
    }
    function advanceEpoch(purpose) {
      try {
        var previous = readEpochs();
        if (!previous) throw new Error('Privacy state unavailable');
        var random = randomOpaqueId();
        if (!random) throw new Error('Privacy generation unavailable');
        var next = 'r1:' + random;
        if (!UUID.test(next.slice(3)) || next === previous[purpose]) throw new Error('Invalid privacy generation');
        win.localStorage.setItem(EPOCH_KEYS[purpose], next);
        if (win.localStorage.getItem(EPOCH_KEYS[purpose]) !== next) throw new Error('Privacy generation not persisted');
        return true;
      } catch (_) {
        // A shared poison value closes other tabs too where storage still works.
        try { win.localStorage.setItem(EPOCH_KEYS[purpose], 'blocked'); } catch (_) {}
        privacyCleanupFailed = true;
        blockSharedClaims();
        return false;
      }
    }
    function observeRevocations(current) {
      ['analytics', 'ads'].forEach(function (purpose) {
        var denied = current[purpose + 'Denied'];
        if (denied && lastKnownPermission[purpose] !== false) advanceEpoch(purpose);
        if (denied) lastKnownPermission[purpose] = false;
        else if (current[purpose]) lastKnownPermission[purpose] = true;
      });
    }

    function now() { return win.Date ? win.Date.now() : Date.now(); }
    function validAttempt(record, route) {
      return !!record && record.route === route && typeof record.createdAt === 'number' &&
        record.createdAt <= now() && now() - record.createdAt <= ATTEMPT_TTL;
    }
    function returnedAttempt() {
      try {
        var url = new URL(win.location.href);
        var raw = url.hash.slice(1);
        var route = routeForPath(url.pathname);
        if (!route || raw.indexOf(NONCE_PREFIX) !== 0) return null;
        var id = raw.slice(NONCE_PREFIX.length);
        if (!UUID.test(id)) return null;
        return { id: id.toLowerCase(), route: route };
      } catch (_) { return null; }
    }
    function claimOnce(id, createdAt) {
      // IDB add() in a readwrite transaction is a unique-key atomic claim across tabs.
      // Commit must complete before emission. Open/block/error/timeout fail closed.
      return new Promise(function (resolve) {
        var request, db, tx, finished = false;
        var timer = win.setTimeout(function () { finish(false); }, CLAIM_TIMEOUT);
        var cancel = function () { finish(false); };
        activeClaims.push(cancel);
        function finish(won) {
          if (finished) return;
          finished = true;
          win.clearTimeout(timer);
          activeClaims = activeClaims.filter(function (item) { return item !== cancel; });
          if (!won && tx) { try { tx.abort(); } catch (_) {} }
          if (db) { try { db.close(); } catch (_) {} }
          resolve(won);
        }
        try {
          if (!win.indexedDB || !anyAllowed() || privacyCleanupFailed) { finish(false); return; }
          request = win.indexedDB.open(CLAIM_DB, 1);
          request.onupgradeneeded = function () {
            if (finished) { try { request.transaction.abort(); } catch (_) {} return; }
            if (!request.result.objectStoreNames.contains(CLAIM_STORE)) request.result.createObjectStore(CLAIM_STORE, { keyPath: 'id' });
          };
          request.onerror = request.onblocked = function () { finish(false); };
          request.onsuccess = function () {
            db = request.result;
            if (finished) { db.close(); return; }
            if (!anyAllowed() || privacyCleanupFailed) { finish(false); return; }
            try {
              tx = db.transaction(CLAIM_STORE, 'readwrite');
              tx.oncomplete = function () { finish(true); };
              tx.onerror = tx.onabort = function () { finish(false); };
              var store = tx.objectStore(CLAIM_STORE);
              var blocked = store.get(PRIVACY_BLOCK);
              blocked.onsuccess = function () { if (blocked.result) finish(false); };
              blocked.onerror = function () { finish(false); };
              // Expired pending attempts cannot emit; older shared claims can be removed.
              var cursor = store.openCursor();
              cursor.onsuccess = function () {
                var item = cursor.result;
                if (!item) return;
                if (typeof item.value.createdAt === 'number' && item.value.createdAt < now() - ATTEMPT_TTL) item.delete();
                item.continue();
              };
              var added = store.add({ id: id, createdAt: createdAt });
              added.onerror = function () { finish(false); };
            } catch (_) { finish(false); }
          };
        } catch (_) { finish(false); }
      });
    }
    function blockSharedClaims() {
      // If the synchronous privacy signal cannot persist, atomically replace
      // tracking claims with a no-identifier deny control in the same shared DB.
      // Old claims survive if this transaction aborts; never clear them first.
      var request, db;
      try {
        if (!win.indexedDB) return;
        request = win.indexedDB.open(CLAIM_DB, 1);
        request.onupgradeneeded = function () {
          if (!request.result.objectStoreNames.contains(CLAIM_STORE)) request.result.createObjectStore(CLAIM_STORE, { keyPath: 'id' });
        };
        request.onerror = request.onblocked = function () {};
        request.onsuccess = function () {
          db = request.result;
          try {
            var tx = db.transaction(CLAIM_STORE, 'readwrite');
            tx.oncomplete = tx.onerror = tx.onabort = function () { try { db.close(); } catch (_) {} };
            var store = tx.objectStore(CLAIM_STORE);
            store.clear();
            store.put({ id: PRIVACY_BLOCK, kind: 'privacy-control' });
          } catch (_) { db.close(); }
        };
      } catch (_) { if (db) { try { db.close(); } catch (_) {} } }
    }
    function clearSharedClaims() {
      activeClaims.slice().forEach(function (cancel) { cancel(); });
      if (privacyCleanupFailed) return; // The atomic fallback deny control must survive.
      try {
        if (!win.indexedDB) return;
        var deletion = win.indexedDB.deleteDatabase(CLAIM_DB);
        deletion.onerror = deletion.onblocked = function () { privacyCleanupFailed = true; };
      } catch (_) { privacyCleanupFailed = true; }
    }

    function purposes() {
      var unavailable = { ready: false, analytics: false, ads: false, analyticsDenied: false, adsDenied: false };
      try {
        var controller = win.__chaoConsentV1;
        if (!controller || controller.version !== 1 || typeof controller.readEffective !== 'function') return unavailable;
        var state = controller.readEffective();
        if (!state || state.version !== 1 || state.ready !== true) return unavailable;
        return {
          ready: true,
          analytics: state.analytics === true,
          ads: state.marketing === true && state.saleOfData === true,
          analyticsDenied: state.analytics === false,
          adsDenied: state.marketing === false || state.saleOfData === false
        };
      } catch (_) { return unavailable; }
    }
    function anyAllowed() {
      var state = purposes();
      return state.analytics || state.ads;
    }
    function maskFor(record) {
      var epochs = readEpochs();
      return {
        analytics: !!epochs && !!record && !!record.eligible && !!record.epochs &&
          record.eligible.analytics === true && record.epochs.analytics === epochs.analytics,
        ads: !!epochs && !!record && !!record.eligible && !!record.epochs &&
          record.eligible.ads === true && record.epochs.ads === epochs.ads
      };
    }
    function invalidateDenied() {
      var current = purposes();
      // Write loss generations before deleting any shared deduplication claims.
      // Sleeping tabs compare generations later, even if they missed every event.
      observeRevocations(current);
      syncCampaignContext(current);
      if (current.analytics || current.ads) fullDenialCleaned = false;
      // An unknown purpose is not a withdrawal. Keep shared deduplication until
      // BOTH purposes are explicitly denied and their loss generations persisted.
      if (current.analyticsDenied && current.adsDenied) {
        if (fullDenialCleaned) return;
        fullDenialCleaned = true;
        clearSharedClaims();
        try {
          var existingStore = win.sessionStorage;
          existingStore.removeItem(PENDING_KEY);
          existingStore.removeItem(RECEIPTS_KEY);
        } catch (_) { privacyCleanupFailed = true; }
        return;
      }
      if (!current.analytics && !current.ads) return;
      var pending = readLedger(PENDING_KEY);
      if (!pending) return;
      var changed = false;
      Object.keys(pending).forEach(function (id) {
        var item = pending[id];
        var mask = maskFor(item);
        if (current.analyticsDenied) mask.analytics = false;
        if (current.adsDenied) mask.ads = false;
        if (!mask.analytics && !mask.ads) { delete pending[id]; changed = true; }
        else if (item && (item.eligible.analytics !== mask.analytics || item.eligible.ads !== mask.ads)) {
          item.eligible = mask; changed = true;
        }
      });
      if (changed && !writeLedger(PENDING_KEY, pending)) {
        privacyCleanupFailed = true;
        try { win.sessionStorage.removeItem(PENDING_KEY); } catch (_) {}
      }
    }
    // Campaign context is local to this browser tab/session and never joins the
    // Google payload. Only the nine named fields can reach the native contact POST.
    function initialCampaignNavigation() {
      try {
        var entries = win.performance.getEntriesByType('navigation');
        return entries.length === 1 && entries[0].type === 'navigate';
      } catch (_) { return false; } // Unknown/reload/history never reacquires a URL.
    }
    function newCampaignVisit(fresh) {
      return { fresh: fresh === true, replaced: false, attempted: { analytics: false, ads: false } };
    }
    function campaignName(key) { return 'contact[chao_' + key + ']'; }
    function validCampaignValue(key, value) {
      if (typeof value !== 'string' || value.length === 0) return false;
      if (CAMPAIGN_FIELDS.ads.indexOf(key) !== -1) return value.length <= 256 && /^[A-Za-z0-9._~-]+$/.test(value);
      // Bounded campaign labels, including normal punctuation and Unicode.
      // Reject blank/control/HTML/email/URL values; link authors must avoid PII.
      return value.length <= 160 && value.trim().length > 0 &&
        !/[\u0000-\u001f\u007f<>@]/.test(value) && !/(?:https?:|www\.|\/\/)/i.test(value);
    }
    function campaignQuery() {
      try { return new URL(win.location.href).searchParams; } catch (_) { return null; }
    }
    function hasCampaignQuery(query) {
      return !!query && ['analytics', 'ads'].some(function (purpose) {
        return CAMPAIGN_FIELDS[purpose].some(function (key) { return query.has(key); });
      });
    }
    function queryCampaignValues(query, purpose) {
      var result = {}, invalid = false;
      CAMPAIGN_FIELDS[purpose].forEach(function (key) {
        var values = query.getAll(key);
        if (!values.length) return;
        // A malformed/blank/duplicate field rejects its whole purpose bundle.
        if (values.length !== 1 || !validCampaignValue(key, values[0])) invalid = true;
        else result[key] = values[0];
      });
      return invalid || !Object.keys(result).length ? null : result;
    }
    function readCampaignRecords() {
      try {
        var raw = win.sessionStorage.getItem(CAMPAIGN_KEY);
        if (raw === null) return {};
        if (raw.length > 4000) return {};
        var records = JSON.parse(raw);
        return records && typeof records === 'object' && !Array.isArray(records) ? records : {};
      } catch (_) { campaignFailed = true; return {}; }
    }
    function validCampaignRecord(record, purpose, epochs) {
      if (!record || !epochs || record.epoch !== epochs[purpose] || typeof record.createdAt !== 'number' ||
          record.createdAt > now() || now() - record.createdAt > CAMPAIGN_TTL ||
          !record.values || typeof record.values !== 'object' || Array.isArray(record.values)) return false;
      var keys = Object.keys(record.values);
      return keys.length > 0 && keys.length <= CAMPAIGN_FIELDS[purpose].length && keys.every(function (key) {
        return CAMPAIGN_FIELDS[purpose].indexOf(key) !== -1 && validCampaignValue(key, record.values[key]);
      });
    }
    function saveCampaignRecords(records) {
      try {
        var store = win.sessionStorage;
        if (!Object.keys(records).length) {
          if (store.getItem(CAMPAIGN_KEY) !== null) store.removeItem(CAMPAIGN_KEY);
          if (store.getItem(CAMPAIGN_KEY) !== null) throw new Error('Campaign cleanup failed');
        } else {
          var raw = JSON.stringify(records);
          if (store.getItem(CAMPAIGN_KEY) !== raw) store.setItem(CAMPAIGN_KEY, raw);
          if (store.getItem(CAMPAIGN_KEY) !== raw) throw new Error('Campaign storage failed');
        }
        return true;
      } catch (_) { campaignFailed = true; return false; }
    }
    function ownedCampaignFields(form, key) {
      return Array.from(form.querySelectorAll('[name="' + campaignName(key) + '"]')).filter(function (field) {
        return field.tagName === 'INPUT' && field.type === 'hidden' && field.getAttribute(CAMPAIGN_ATTRIBUTE) === 'v1';
      });
    }
    function pruneCampaignFields(form, records) {
      ['analytics', 'ads'].forEach(function (purpose) {
        CAMPAIGN_FIELDS[purpose].forEach(function (key) {
          var value = records[purpose] && records[purpose].values[key];
          ownedCampaignFields(form, key).forEach(function (field) {
            if (value === undefined || field.value !== value) field.remove();
          });
        });
      });
    }
    function syncCampaignContext(current) {
      if (current.ready !== true) {
        // A fresh document may load before Shopify's asynchronous privacy API.
        // Do not use or erase previously permitted context during initialization.
        Array.from(doc.querySelectorAll(WRAPPER + ' form.contact-form')).forEach(function (form) {
          if (eligibleForm(form)) pruneCampaignFields(form, {});
        });
        return {};
      }
      var records = readCampaignRecords(), clean = {}, epochs = readEpochs();
      var query = campaignQuery(), incoming = hasCampaignQuery(query);
      if (!incoming) {
        campaignVisit.attempted.analytics = true;
        campaignVisit.attempted.ads = true;
      }
      var fresh = campaignVisit.fresh && incoming;
      ['analytics', 'ads'].forEach(function (purpose) {
        if (current[purpose + 'Denied']) campaignVisit.attempted[purpose] = true;
        if (!campaignFailed && !privacyCleanupFailed && current[purpose] && validCampaignRecord(records[purpose], purpose, epochs)) {
          clean[purpose] = { epoch: records[purpose].epoch, createdAt: records[purpose].createdAt, values: records[purpose].values };
        }
      });
      if (fresh && !campaignVisit.replaced) {
        // A new campaign-bearing navigation replaces BOTH old purpose bundles.
        // A new gclid alone must not acquire the preceding campaign's UTM labels.
        clean = {};
        campaignVisit.replaced = true;
      }
      ['analytics', 'ads'].forEach(function (purpose) {
        if (!fresh || campaignVisit.attempted[purpose] || !current[purpose]) return;
        campaignVisit.attempted[purpose] = true;
        if (!epochs || campaignFailed || privacyCleanupFailed) return;
        var values = queryCampaignValues(query, purpose);
        if (values) clean[purpose] = { epoch: epochs[purpose], createdAt: now(), values: values };
      });
      if (campaignFailed || privacyCleanupFailed || !epochs) clean = {};
      if (!saveCampaignRecords(clean)) clean = {};
      Array.from(doc.querySelectorAll(WRAPPER + ' form.contact-form')).forEach(function (form) {
        if (eligibleForm(form)) pruneCampaignFields(form, clean);
      });
      return clean;
    }
    function applyCampaignFields(form) {
      var current = purposes(), records = syncCampaignContext(current), epochs = readEpochs();
      ['analytics', 'ads'].forEach(function (purpose) {
        var record = records[purpose];
        if (!current[purpose] || !validCampaignRecord(record, purpose, epochs)) return;
        var keys = Object.keys(record.values);
        // Never overwrite merchant-owned controls, and never post half a bundle.
        var safe = CAMPAIGN_FIELDS[purpose].every(function (key) {
          var fields = form.querySelectorAll('[name="' + campaignName(key) + '"]');
          return fields.length === 0 || (fields.length === 1 && ownedCampaignFields(form, key).length === 1);
        });
        if (!safe) {
          CAMPAIGN_FIELDS[purpose].forEach(function (key) { ownedCampaignFields(form, key).forEach(function (field) { field.remove(); }); });
          return;
        }
        keys.forEach(function (key) {
          var field = ownedCampaignFields(form, key)[0];
          if (!field) {
            field = doc.createElement('input');
            field.type = 'hidden';
            field.name = campaignName(key);
            field.setAttribute(CAMPAIGN_ATTRIBUTE, 'v1');
            form.appendChild(field);
          }
          field.value = record.values[key];
        });
      });
    }
    function noteCampaignNavigation(event) {
      if (event.isTrusted !== true || event.defaultPrevented) return;
      if (typeof event.button === 'number' && event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var target = event.target && (event.target.nodeType === 3 ? event.target.parentElement : event.target);
      var link = target && typeof target.closest === 'function' ? target.closest('a[href]') : null;
      if (!link) return;
      try {
        var target = link.getAttribute('target');
        if (target && target.toLowerCase() !== '_self') return;
        if (link.getAttribute('download') !== null) return;
        var url = new URL(link.getAttribute('href'), win.location.href);
        if (url.origin === win.location.origin && /^https?:$/.test(url.protocol)) {
          // Retain only the DOM node and a short expiry; no copied URL or query.
          campaignVisit = newCampaignVisit(false);
          nextCampaignNavigation = { link: link, at: now() };
        }
      } catch (_) { /* No campaign acquisition from unknown navigation. */ }
    }
    function matchesCampaignNavigation() {
      try {
        if (!nextCampaignNavigation || now() < nextCampaignNavigation.at || now() - nextCampaignNavigation.at > 10000) return false;
        var target = new URL(nextCampaignNavigation.link.getAttribute('href'), win.location.href);
        var actual = new URL(win.location.href);
        return target.origin === actual.origin && target.pathname === actual.pathname && target.search === actual.search;
      } catch (_) { return false; }
    }

    function bindConsent() {
      var controller = win.__chaoConsentV1;
      if (controller && controller !== subscribedConsent && typeof controller.subscribe === 'function') {
        controller.subscribe(refresh);
        subscribedConsent = controller;
      }
    }

    function storage() {
      if (privacyCleanupFailed || !anyAllowed()) return null;
      try { return win.sessionStorage; } catch (_) { return null; }
    }
    function readLedger(key) {
      try {
        var store = storage();
        if (!store) return null;
        var raw = store.getItem(key);
        if (raw === null) return {};
        var ledger = JSON.parse(raw);
        return ledger && typeof ledger === 'object' && !Array.isArray(ledger) ? ledger : null;
      } catch (_) { return null; }
    }
    function writeLedger(key, ledger) {
      try {
        var store = storage();
        if (!store) return false;
        var raw = JSON.stringify(ledger);
        store.setItem(key, raw);
        return store.getItem(key) === raw;
      } catch (_) { return false; }
    }
    function emit(payload, captured, capturedEpochs) {
      var current = purposes();
      var epochs = capturedEpochs ? readEpochs() : null;
      if (capturedEpochs && !epochs) return false;
      var allowed = {
        analytics: captured.analytics === true && current.analytics && (!capturedEpochs || capturedEpochs.analytics === epochs.analytics),
        ads: captured.ads === true && current.ads && (!capturedEpochs || capturedEpochs.ads === epochs.ads)
      };
      if (!allowed.analytics && !allowed.ads) return false;
      try {
        var controller = win.__chaoConsentV1;
        if (!controller || typeof controller.queueState !== 'function' || controller.queueState() !== true) return false;
        if (!win.dataLayer || typeof win.dataLayer.push !== 'function') return false;
        // queueState can synchronously run GTM listeners: reread immediately before
        // measurement emission so a concurrent permission loss cannot sneak through.
        current = purposes();
        epochs = capturedEpochs ? readEpochs() : null;
        if (capturedEpochs && !epochs) return false;
        allowed.analytics = captured.analytics === true && current.analytics && (!capturedEpochs || capturedEpochs.analytics === epochs.analytics);
        allowed.ads = captured.ads === true && current.ads && (!capturedEpochs || capturedEpochs.ads === epochs.ads);
        if (!allowed.analytics && !allowed.ads) return false;
        payload.analytics_eligible = allowed.analytics;
        payload.ads_eligible = allowed.ads;
        win.dataLayer.push(payload);
        relayAcceptedGoogle(payload, captured, capturedEpochs);
        return true;
      } catch (_) { return false; }
    }
    function relayAcceptedGoogle(payload, captured, capturedEpochs) {
      // The live P4 container retains every non-form producer and existing base
      // Google tags. The pre-loader fsl policy retires only its submit listeners.
      // Use Google's standard arguments-object command; no new config/pageview,
      // loader, user-data input, campaign parameter or conversion value is sent.
      if (payload.event !== 'chao_enquiry_success' || !UUID.test(payload.submission_id) ||
          (payload.form_route !== 'contact' && payload.form_route !== 'quote')) return;
      function permitted(purpose) {
        var current = purposes();
        var epochs = capturedEpochs ? readEpochs() : null;
        return captured[purpose] === true && current[purpose] === true &&
          (!capturedEpochs || (epochs && capturedEpochs[purpose] === epochs[purpose]));
      }
      function command() { win.dataLayer.push(arguments); }
      // Recheck immediately before each command. A synchronous queue observer
      // that withdraws another purpose must not allow the second command.
      if (permitted('ads')) {
        command('event', 'conversion', {
          send_to: 'AW-812267399/' + (payload.form_route === 'quote' ?
            't_pRCLr9jYQaEIfvqIMD' : 'IddtCLH9jYQaEIfvqIMD'),
          transaction_id: payload.submission_id
        });
      }
      // Live GA4 tag86 measured contact only; do not add a new quote GA4 event.
      if (payload.form_route === 'contact' && permitted('analytics')) {
        command('event', 'contact_form_fill', {
          send_to: 'G-M3F28N0K17',
          form_route: payload.form_route,
          submission_id: payload.submission_id
        });
      }
    }
    function newId() { return anyAllowed() ? randomOpaqueId() : null; }
    function randomOpaqueId() {
      try {
        if (!win.crypto) return null;
        if (typeof win.crypto.randomUUID === 'function') {
          var id = win.crypto.randomUUID();
          return UUID.test(id) ? id.toLowerCase() : null;
        }
        if (typeof win.crypto.getRandomValues !== 'function') return null;
        var bytes = new Uint8Array(16);
        win.crypto.getRandomValues(bytes);
        bytes[6] = (bytes[6] & 15) | 64;
        bytes[8] = (bytes[8] & 63) | 128;
        var hex = Array.from(bytes, function (byte) { return ('0' + byte.toString(16)).slice(-2); }).join('');
        return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' + hex.slice(16, 20) + '-' + hex.slice(20);
      } catch (_) { return null; }
    }
    function getField(form, name) {
      return form.querySelector('input[name="' + name + '"]');
    }
    function setOwnedField(form, name, value) {
      var field = getField(form, name);
      if (!field) {
        field = doc.createElement('input');
        field.type = 'hidden';
        field.name = name;
        field.setAttribute(OWNED_ATTRIBUTE, 'v3');
        form.appendChild(field);
      }
      field.value = value;
      return field;
    }
    function clearAttemptFields(form) {
      Array.from(form.querySelectorAll('input[' + OWNED_ATTRIBUTE + '="v3"]')).forEach(function (field) { field.remove(); });
      var original = form.getAttribute(ORIGINAL_ACTION);
      if (original !== null) {
        form.setAttribute('action', original);
        form.removeAttribute(ORIGINAL_ACTION);
      }
    }
    function canOwnFields(form) {
      // Do not replace a merchant's unrelated redirect or tracking fields.
      if (form.querySelectorAll('[name="' + RETURN_FIELD + '"]').length) return false;
      return [ID_FIELD, ROUTE_FIELD].every(function (name) {
        var fields = form.querySelectorAll('[name="' + name + '"]');
        return fields.length === 0 || (fields.length === 1 && fields[0].tagName === 'INPUT' &&
          fields[0].type === 'hidden' && fields[0].getAttribute(OWNED_ATTRIBUTE) === 'v3');
      });
    }
    function eligibleForm(form) {
      if (!form || form.tagName !== 'FORM' || !form.classList.contains('contact-form') || !form.closest(WRAPPER)) return false;
      var formType = getField(form, 'form_type');
      if (!formType || formType.value !== 'contact') return false;
      try {
        var action = new URL(form.getAttribute('action') || '', win.location.href);
        return action.origin === win.location.origin && action.pathname === '/contact' && form.getAttribute('method').toLowerCase() === 'post';
      } catch (_) { return false; }
    }

    function captureAttempt(event) {
      var form = event.target;
      var route = routeForPath(win.location.pathname);
      if (!route || !eligibleForm(form)) return;
      try {
        invalidateDenied();
        var current = purposes();
        if (!current.analytics && !current.ads) { clearAttemptFields(form); return; }
        if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
        applyCampaignFields(form);
        if (!canOwnFields(form)) return;
        var pending = readLedger(PENDING_KEY);
        var receipts = readLedger(RECEIPTS_KEY);
        if (!pending || !receipts) { clearAttemptFields(form); return; }
        var field = getField(form, ID_FIELD);
        var id = field && UUID.test(field.value) ? field.value.toLowerCase() : null;
        if (!id || own(receipts, id) || !own(pending, id) || !validAttempt(pending[id], route)) id = newId();
        if (!id) { clearAttemptFields(form); return; }
        var previous = own(pending, id) ? pending[id] : null;
        var epochs = previous ? previous.epochs : readEpochs();
        if (!epochs) { clearAttemptFields(form); return; }
        var captured = previous ? maskFor(previous) : { analytics: current.analytics, ads: current.ads };
        var eligible = { analytics: captured.analytics && current.analytics, ads: captured.ads && current.ads };
        if (!eligible.analytics && !eligible.ads) { clearAttemptFields(form); return; }
        pending[id] = { route: route, createdAt: previous ? previous.createdAt : now(), eligible: eligible, epochs: epochs };
        // Prune expired records, but never turn corrupt data into valid acceptance.
        Object.keys(pending).forEach(function (key) {
          if (!pending[key] || typeof pending[key].createdAt !== 'number' || now() - pending[key].createdAt > ATTEMPT_TTL) delete pending[key];
        });
        if (!writeLedger(PENDING_KEY, pending)) { clearAttemptFields(form); return; }
        setOwnedField(form, ID_FIELD, id);
        setOwnedField(form, ROUTE_FIELD, route);
        if (form.getAttribute(ORIGINAL_ACTION) === null) form.setAttribute(ORIGINAL_ACTION, form.getAttribute('action'));
        // Fragments are not sent to Shopify. The HTTP endpoint/method and default
        // native success/error redirect remain unchanged; runtime inheritance is QA-gated.
        form.setAttribute('action', '/contact#' + NONCE_PREFIX + id);
        // No return_to, success flag, browser-history write, preventDefault, fetch or retry.
      } catch (_) {
        try { clearAttemptFields(form); } catch (_) { /* Native submission remains untouched. */ }
      }
    }

    function scanAcceptance() {
      invalidateDenied();
      if (!anyAllowed() || privacyCleanupFailed) return;
      var pending = readLedger(PENDING_KEY);
      var receipts = readLedger(RECEIPTS_KEY);
      if (!pending || !receipts) return;
      if (doc.querySelectorAll(ERROR_SELECTOR).length) {
        // A native error may render at /contact without the return nonce. There is
        // no successful attempt to associate: discard this tab's pending attempts.
        if (Object.keys(pending).length && !writeLedger(PENDING_KEY, {})) privacyCleanupFailed = true;
        return;
      }
      var returned = returnedAttempt();
      if (!returned) return;
      var id = returned.id;
      var route = returned.route;
      var markers = Array.from(doc.querySelectorAll(ACCEPTANCE_SELECTOR));
      if (markers.length !== 1 || markers[0].getAttribute('data-chao-form-route') !== route) return;
      if (own(receipts, id) || claimsInFlight[id] || !own(pending, id) || !validAttempt(pending[id], route)) return;
      var captured = maskFor(pending[id]);
      var current = purposes();
      if (!(captured.analytics && current.analytics) && !(captured.ads && current.ads)) return;
      var createdAt = pending[id].createdAt;
      // Reserve locally first; an uncertain claim or throwing queue is never replayed.
      receipts[id] = { route: route, createdAt: createdAt };
      if (!writeLedger(RECEIPTS_KEY, receipts)) return;
      claimsInFlight[id] = true;
      claimOnce(id, createdAt).then(function (won) {
        delete claimsInFlight[id];
        invalidateDenied();
        var latest = readLedger(PENDING_KEY);
        if (!latest || !own(latest, id)) return;
        var record = latest[id];
        var finalMask = maskFor(record);
        var stillValid = validAttempt(record, route);
        delete latest[id];
        if (!writeLedger(PENDING_KEY, latest)) { privacyCleanupFailed = true; return; }
        if (!won || !stillValid || privacyCleanupFailed) return;
        // Intersect captured, irreversibly narrowed pending, and current permission.
        emit({ event: 'chao_enquiry_success', event_name: 'contact_form_fill', form_route: route, submission_id: id }, {
          analytics: captured.analytics && finalMask.analytics,
          ads: captured.ads && finalMask.ads
        }, record.epochs);
      }).catch(function () { delete claimsInFlight[id]; });
    }

    function captureClick(event) {
      var current = purposes();
      if (!current.analytics && !current.ads) return;
      if (typeof event.button === 'number' && event.button !== 0) return;
      var target = event.target && (event.target.nodeType === 3 ? event.target.parentElement : event.target);
      var link = target && typeof target.closest === 'function' ? target.closest('a[href]') : null;
      if (!link) return;
      var eventName = classifyLink(link.getAttribute('href'), win.location.href, URL);
      if (eventName) emit({ event: 'chao_custom_interaction', event_name: eventName }, current);
      // Link URLs, phone numbers, email addresses and form contents are not queued.
    }

    function bindInstantClick() {
      if (!instantClickBound && win.InstantClick && typeof win.InstantClick.on === 'function') {
        win.InstantClick.on('change', function () {
          campaignVisit = newCampaignVisit(matchesCampaignNavigation());
          nextCampaignNavigation = null;
          refresh();
        });
        instantClickBound = true;
      }
    }
    function restoreNativeAnchor() {
      // UI-only: retain the native jump to the form after its unique fragment.
      // This neither reads tracking storage nor depends on consent/IDB availability.
      var returned = returnedAttempt();
      if (!returned) return;
      var forms = Array.from(doc.querySelectorAll(WRAPPER + ' form.contact-form'));
      if (forms.length !== 1) return;
      var anchor = forms[0].closest(WRAPPER);
      var id = NONCE_PREFIX + returned.id;
      if (anchor && anchor.id !== id) {
        anchor.id = id;
        if (typeof anchor.scrollIntoView === 'function') anchor.scrollIntoView({ block: 'start' });
      }
    }
    function refresh() {
      restoreNativeAnchor();
      bindConsent();
      invalidateDenied();
      var current = purposes();
      if (!current.analytics && !current.ads && (current.analyticsDenied || current.adsDenied)) {
        Array.from(doc.querySelectorAll(WRAPPER + ' form.contact-form')).forEach(function (form) {
          if (eligibleForm(form)) {
            try { clearAttemptFields(form); } catch (_) { /* No tracking work on denial. */ }
          }
        });
      }
      bindInstantClick();
      scanAcceptance();
    }
    var controller = { refresh: refresh };
    win[INSTALLED] = controller;
    doc.addEventListener('submit', captureAttempt, true);
    doc.addEventListener('click', noteCampaignNavigation, true);
    doc.addEventListener('DOMContentLoaded', refresh);
    doc.addEventListener('visitorConsentCollected', refresh);
    doc.addEventListener('shopify:section:load', refresh);
    win.addEventListener('pageshow', function (event) {
      if (event && event.persisted) {
        nextCampaignNavigation = null;
        campaignVisit = newCampaignVisit(false);
      }
      refresh();
    });
    win.addEventListener('pagehide', function () {
      nextCampaignNavigation = null;
      campaignVisit = newCampaignVisit(false);
    });
    win.addEventListener('popstate', function () {
      nextCampaignNavigation = null;
      campaignVisit = newCampaignVisit(false);
      refresh();
    }, true);
    win.addEventListener('storage', function (event) {
      if (!event || event.key === null || event.key === EPOCH_KEYS.analytics || event.key === EPOCH_KEYS.ads) refresh();
    });
    if (win.MutationObserver && doc.documentElement) {
      var observer = new win.MutationObserver(refresh);
      observer.observe(doc.documentElement, { childList: true, subtree: true });
    }
    refresh();
    return controller;
  }

  return { install: install, classifyLink: classifyLink, routeForPath: routeForPath };
});
